import { fg } from '@atlassian/jira-feature-gating';
import { DependencyFilterOption } from '@atlassian/jira-filters/src/ui/filters/dependencies/types';
import type { FilterableIssue, MatcherCreator } from '../types';

export const dependenciesMatcherCreator: MatcherCreator<string[], FilterableIssue> = (
	dependenciesFilter,
) => {
	if (
		dependenciesFilter &&
		dependenciesFilter.includes(DependencyFilterOption.OFF_TRACK) &&
		fg('dependency_visualisation_program_board_fe_and_be')
	) {
		return (issue) => !!issue.isDependencyOfftrack;
	}

	return () => true;
};
